import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Atendente } from '../models/atendente.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtendenteService {

  private _apiUrl = environment.apiUrl + "/v1/Atendentes";
  constructor(private httpClient: HttpClient) { }

  private atendentesSubject = new BehaviorSubject<Atendente[]>([]);
  atendentes$ = this.atendentesSubject.asObservable();

  carregarAtendentes(listaContatoGerado: string): Observable<Atendente[]> {
    return this.httpClient.get<Atendente[]>(`${this._apiUrl}/lista-contatos-gerados/${listaContatoGerado}`)
  }

  adicionarAtendente(novoAtendente: Atendente, listaContatoGeradoid:string): Observable<string> {

    let payload = {
      listaContatoGeradoId: listaContatoGeradoid,
      usuarioId: novoAtendente.id
    }
    
    return this.httpClient.post<string>(`${this._apiUrl}`, payload);
  }

  excluirAtendente(usuarioId:string, listaContatoGeradoId:string, ): Observable<string> {
    return this.httpClient.delete<string>(`${this._apiUrl}/${usuarioId}/${listaContatoGeradoId}`)
  }

  carregar(listaContatoGerado: string): void {
    this.carregarAtendentes(listaContatoGerado);
  }
}
